import { useState } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import { FaLeaf, FaMinus, FaMoneyBillWave, FaPlus, FaTrash } from "react-icons/fa";
import { FiArrowRight, FiX } from "react-icons/fi";

const persianNumber = new Intl.NumberFormat("fa-IR");
const GREEN = "#3F5A3D";
const TERRACOTTA = "#B0552F";

const GardenFreshCartTheme = (props) => {
  const {
    restaurantData,
    cart,
    tableNumber,
    setTableNumber,
    queryTable,
    tableSuppliedByQr,
    submitting,
    error,
    setError,
    summary,
    changeQuantity,
    removeItem,
    validateCheckout,
    submitOrder,
    goToMenu,
    formatPersianPrice,
  } = props;
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);

  const openPayment = () => {
    if (validateCheckout()) setShowPaymentModal(true);
  };

  const handleSubmit = async () => {
    const success = await submitOrder();
    if (!success) setShowReceipt(false);
  };

  return (
    <div className="min-h-screen pb-28" dir="rtl" style={{ backgroundColor: "#F6F2E7" }}>
      <header className="sticky top-0 z-30 shadow-sm" style={{ backgroundColor: GREEN }}>
        <div className="mx-auto flex h-16 max-w-3xl items-center gap-3 px-4 text-white">
          <button type="button" onClick={goToMenu} aria-label="بازگشت به منو" className="flex h-11 w-11 items-center justify-center rounded-xl text-xl hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white"><FiArrowRight /></button>
          <h1 className="flex-1 font-black">سبد سفارش</h1>
          <span className="text-xs text-white/80">{restaurantData?.name}</span>
        </div>
      </header>

      <main className="mx-auto max-w-3xl space-y-4 p-4">
        {error && <div role="alert" className="rounded-2xl border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>}
        {!cart.length ? (
          <div className="rounded-3xl border border-dashed border-[#D8CFB4] bg-white/70 px-4 py-16 text-center">
            <FaLeaf className="mx-auto text-4xl" style={{ color: "#B7C4AC" }} aria-hidden="true" />
            <p className="mt-4 font-bold text-gray-800">سبد سفارش خالی است</p>
            <button type="button" onClick={goToMenu} className="mt-4 min-h-11 rounded-full px-5 text-sm font-bold text-white" style={{ backgroundColor: GREEN }}>بازگشت به منو</button>
          </div>
        ) : (
          <>
            <section className="space-y-3" aria-label="آیتم‌های سبد">
              {cart.map((item) => (
                <article key={item._id} className="flex gap-3 rounded-3xl bg-white p-3 shadow-sm">
                  <div className="h-20 w-20 shrink-0 overflow-hidden rounded-2xl bg-[#EFE9D8]">{item.image ? <img src={item.image} alt={item.name} className="h-full w-full object-cover" /> : <span className="flex h-full items-center justify-center" style={{ color: "#8CA37E" }}><FaLeaf /></span>}</div>
                  <div className="min-w-0 flex-1"><h2 className="truncate font-bold text-gray-900">{item.name}</h2><p className="mt-1 text-xs text-gray-500">هر عدد {formatPersianPrice(item.price)}</p><p className="mt-2 text-sm font-black" style={{ color: TERRACOTTA }}>{formatPersianPrice(item.price * item.quantity)}</p></div>
                  <div className="flex flex-col items-center justify-between">
                    <button type="button" onClick={() => removeItem(item)} aria-label={`حذف ${item.name}`} className="rounded-lg p-2 text-red-500 hover:bg-red-50"><FaTrash size={13} /></button>
                    <div className="flex items-center rounded-full bg-[#F0EBDC]"><button type="button" onClick={() => changeQuantity(item, -1)} aria-label={`کم کردن ${item.name}`} className="flex h-9 w-9 items-center justify-center"><FaMinus size={10} /></button><span className="w-6 text-center text-sm font-bold">{persianNumber.format(item.quantity)}</span><button type="button" onClick={() => changeQuantity(item, 1)} aria-label={`اضافه کردن ${item.name}`} className="flex h-9 w-9 items-center justify-center"><FaPlus size={10} /></button></div>
                  </div>
                </article>
              ))}
            </section>

            {tableSuppliedByQr ? (
              <section className="rounded-3xl bg-white p-4 shadow-sm">
                <p className="text-sm font-bold text-gray-800">شماره میز</p>
                <p className="mt-2 text-lg font-black" style={{ color: GREEN }}>میز {persianNumber.format(queryTable)}</p>
                <p className="mt-1 text-xs text-gray-500">شماره میز شما از طریق کد QR ثبت شده است.</p>
              </section>
            ) : (
              <section className="rounded-3xl bg-white p-4 shadow-sm">
                <label className="block text-sm font-bold text-gray-800">شماره میز
                  <input inputMode="numeric" value={tableNumber} onChange={(event) => { setTableNumber(event.target.value); setError(""); }} placeholder="مثلاً ۱۲" aria-describedby="gf-table-help" className="mt-2 min-h-12 w-full rounded-2xl border-0 bg-[#F6F2E7] p-3 outline-none focus:ring-2" style={{ "--tw-ring-color": GREEN }} />
                </label>
                <p id="gf-table-help" className="mt-2 text-xs text-gray-500">شماره میز برای ارسال صحیح سفارش ضروری است.</p>
              </section>
            )}

            <section className="flex items-center justify-between rounded-3xl bg-white p-4 shadow-sm"><div><p className="text-sm text-gray-500">{persianNumber.format(summary.itemCount)} آیتم</p><p className="font-bold text-gray-800">مبلغ قابل پرداخت</p></div><p className="text-lg font-black" style={{ color: TERRACOTTA }}>{formatPersianPrice(summary.total)}</p></section>
          </>
        )}
      </main>

      {cart.length > 0 && (
        <div className="fixed inset-x-0 bottom-0 z-30 p-3">
          <button type="button" onClick={openPayment} className="mx-auto block min-h-12 w-full max-w-md rounded-full px-5 font-bold text-white shadow-lg focus:outline-none focus:ring-4 focus:ring-white" style={{ backgroundColor: GREEN }}>ثبت سفارش</button>
        </div>
      )}

      <Dialog open={showPaymentModal && !showReceipt} onClose={() => setShowPaymentModal(false)} fullWidth maxWidth="xs" dir="rtl" PaperProps={{ className: "!rounded-3xl" }}>
        <DialogContent className="relative !p-6">
          <IconButton onClick={() => setShowPaymentModal(false)} aria-label="بستن روش‌های پرداخت" className="!absolute !left-3 !top-3"><FiX /></IconButton>
          <h2 className="text-center text-xl font-black">روش پرداخت</h2>
          <div className="mt-6 space-y-3">
            <button type="button" onClick={() => setShowReceipt(true)} className="flex min-h-12 w-full items-center justify-center gap-3 rounded-2xl border border-gray-200 font-bold"><FaMoneyBillWave className="text-green-600" /> پرداخت نقدی در صندوق</button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={showReceipt} onClose={() => !submitting && setShowReceipt(false)} fullWidth maxWidth="xs" dir="rtl" PaperProps={{ className: "max-h-[calc(100dvh-2rem)] !rounded-3xl" }}>
        <DialogContent className="!p-6">
          <h2 className="text-center text-xl font-black">تأیید سفارش نقدی</h2>
          <div className="mt-5 max-h-64 space-y-2 overflow-y-auto">{cart.map((item) => <div key={item._id} className="flex justify-between rounded-2xl bg-[#F6F2E7] p-3 text-sm"><span>{item.name} × {persianNumber.format(item.quantity)}</span><span className="font-bold">{formatPersianPrice(item.price * item.quantity)}</span></div>)}</div>
          <div className="mt-4 flex justify-between border-t border-gray-100 pt-4 font-black"><span>جمع کل</span><span>{formatPersianPrice(summary.total)}</span></div>
          <p className="mt-3 text-center text-sm text-gray-500">پرداخت پس از ثبت سفارش در صندوق انجام می‌شود.</p>
          <div className="mt-5 flex gap-2">
            <button type="button" onClick={() => setShowReceipt(false)} disabled={submitting} className="min-h-11 flex-1 rounded-2xl border border-gray-200 font-bold disabled:opacity-50">بازگشت</button>
            <button type="button" onClick={handleSubmit} disabled={submitting} className="min-h-11 flex-[2] rounded-2xl font-bold text-white disabled:opacity-50" style={{ backgroundColor: GREEN }}>{submitting ? "در حال ثبت…" : "ثبت نهایی سفارش"}</button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default GardenFreshCartTheme;
